module.exports = __webpack_public_path__ + "static/media/user-headset.a4c529f2.svg";